import { Project } from '../../../../@types/projects/types';
import {
  DEFAULT_RESULTS_CURVE_POINTS,
  buildLambdaZoneCurves,
  clampCurvePointCount
} from '../../../utils/curveGeneration';

export class LambdaSystemSaturationCalculationStrategy {
  public calculate(project: Project, numberOfPoints: number = DEFAULT_RESULTS_CURVE_POINTS): Project {
    const zones = project.correlation?.zones;
    const gradDiff = project.correlation?.grad_diff;
    if (!zones?.length || typeof gradDiff !== 'number') {
      return project;
    }

    const pointCount = clampCurvePointCount(numberOfPoints);
    zones.forEach(zone => {
      (['fzi', 'rqi'] as const).forEach(xAxis => {
        const axisZoneValues = zone.zone_values_by_x_axis?.[xAxis] ?? (xAxis === 'fzi' ? zone.zone_values : null);
        if (!axisZoneValues) return;
        const curves = buildLambdaZoneCurves({ ...zone, zone_values: axisZoneValues }, gradDiff, pointCount);
        if (!curves) return;
        zone.zone_curves_by_x_axis = {
          ...(zone.zone_curves_by_x_axis ?? {}),
          [xAxis]: {
            liao_curves: zone.zone_curves_by_x_axis?.[xAxis]?.liao_curves ?? null,
            lambda_curves: curves
          }
        };
        if (xAxis === 'fzi') {
          zone.zone_curves = {
            liao_curves: zone.zone_curves?.liao_curves ?? null,
            lambda_curves: curves
          };
        }
      });
    });

    return project;
  }
}

const calculator = new LambdaSystemSaturationCalculationStrategy();

globalThis.onmessage = (event: MessageEvent<{ project: Project; numberOfPoints?: number }>) => {
  const { project, numberOfPoints = DEFAULT_RESULTS_CURVE_POINTS } = event.data;

  try {
    const resultProject = calculator.calculate(project, numberOfPoints);
    globalThis.postMessage({ status: 'success', data: resultProject });
  } catch (error: any) {
    globalThis.postMessage({ status: 'error', message: error.message });
  }
};
